<template>  
  <div>
    <card card-body-classes="px-3">
      <div slot="header" class="row">
        <div class="col-6">
          <h4 class="card-title f-20-mobile">Grupo Empresarial</h4>
        </div>
      </div>

      <form class="row text-left" @submit="onSubmit">
        <div class="form-group col-6">
          <label>Nome</label>
          <input type="text" v-model="data.name" class="form-control" required>
        </div>
        <div class="form-group col-6">
          <label>Pesquisar Empresa</label>
          <input class="form-control dont-float-mobile" placeholder="Pesquisar..." v-debounce:250ms="pesquisaInstalacao" v-model="query">
        </div>
        <div class="col-6"></div>
        <div class="col-md-12">
          <h3>Instalaçoes Desktop</h3>
          <hr>
        </div>
        <div class="form-group col-3" v-for="customer of deskPesquisa">
          <input type="checkbox" :id="customer.idi" :checked="!customer.already" v-model='customer.already' :value="customer.idi">
          <label class="ml-1" :for="customer.idi">{{ customer.apelido }} - {{customer.cnpj}}</label>
        </div>
        <div class="col-md-12">
          <h3>Instalaçoes App</h3>
          <hr>
        </div>
        <div class="form-group col-3" v-for="customer of appPesquisa">
          <input type="checkbox" :id="customer.idi" :checked="!customer.already" v-model='customer.already' :value="customer.idi">
          <label class="ml-1" :for="customer.idi">{{ customer.apelido }} - {{customer.cnpj}}</label>
        </div>

        <div class="form-group col-12">
          <button class="btn btn-primary">{{ data.id ? 'Editar' : 'Salvar' }}</button>
        </div>
      </form>
    </card>
  </div>
</template>

<script>
  import axios from 'axios'
  import {
    Card,
  } from 'src/components'
import moment from 'moment'
import CustomerGroupService from '@/services/CustomerGroupService.js'
import CustomerService from '@/services/CustomerService.js'

export default {
    components: {
      Card,
      moment
    },
    data() {
      return {
        customers: [],
        query:"",
        appPesquisa: [],
        deskPesquisa: [],
        data: {
          customers: [],
          v2: true
        },
      }
    },
    methods:{
      loadCustomers() {  
        CustomerService.load('?customer_group_id=' + this.$route.params.id + `&query=${this.query}`).then(res => {
          //==========================================
          // Apps
          //==========================================
          let found = false;

          for(let app of res.data.activeApps) {
            app.app = true;
            found = false;

            for(let listApp of res.data.apps) {
              if(app.idi === listApp.idi) {
                found = true
                listApp.already = true
              }

              listApp.app = true;
            }

            if(!found) {
              app.already = true;
              res.data.apps.push(app)
            }
          }

          //==========================================
          // Desks
          //==========================================
          found = false;

          for(let desk of res.data.activeDesks) {
            desk.app = false;
            found = false;

            for(let listDesk of res.data.desks) {
              if(desk.idi === listDesk.idi) {
                found = true
                listDesk.already = true
              }

              listDesk.app = false;
            }

            if(!found) {
              desk.already = true;
              res.data.desks.push(desk)
            }
          }

          this.appPesquisa = res.data.apps;
          this.deskPesquisa = res.data.desks;

          this.$forceUpdate()
        })
        .catch(err => {
          console.error(err)
        })
      },
      pesquisaInstalacao(){
        this.appPesquisa = [];
        this.deskPesquisa = [];
        this.loadCustomers()
      },

      loadGroup(id) {
        CustomerGroupService.show(id).then(res => {
          this.data = res.data
          this.data.v2 = true;
        })
        .catch(err => {
          alert("Erro")
        })
      },
      onSubmit(e) {
        e.preventDefault()

        this.data.customers = {
          app: this.appPesquisa,
          desk: this.deskPesquisa
        };

        if(this.data.id) {
          CustomerGroupService.update(this.data).then(res => {
            this.$router.push('/grupos/')
          })
          .catch(err => {

          })
        } else {
          CustomerGroupService.create(this.data).then(res => {
            this.$router.push('/grupos/')
          })
          .catch(err => {

          })
        }
      }
    },
    mounted() {
      if(this.$route.params.id) {
        this.loadGroup(this.$route.params.id)
      }

      this.loadCustomers()
      
    }
}
</script>

<style>
</style>  